import ContentSectionView from './ContentSectionView';

export default ContentSectionView;
